import {onError, getImageUrl, message, logout, errorHandler, loader, openInNewTab, routeErrorHandler} from '@/libs/helper'
import {getPaymentList, addOganisationPayment, removeOganisationPayment, getOrgSubscriptionsList, changeDefaultOrgPayment, getInvoicesList, getBillingManagerList, removeBillingManager, updateBillingCustomer, getBillingCustomer, getOrgPlanList, changeOrgPlan} from '@/libs/api/api'
import constants from '@/libs/constant/constants'
import {cloneDeep, filter, isEmpty, find, remove} from 'lodash'
import pageRoute from '@/libs/constant/pageRoutes'
const countrydata = require('countrydata');
import countryCode from '@/libs/constant/countrycode'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
import locationFormMixin from '@/mixins/locationFormMixin';
import { mapGetters }  from 'vuex';
import permissions from '@/libs/constant/permissions'

export default {
    name: 'Billing',
    mixins: [OrganisationRolesErrorHandlerMixin, locationFormMixin],
    components: {
        InvitePeople: () => import('@/components/pages/InformationPortal/Organisation/InvitePeople/InvitePeople.vue') 
    },
    props: {
        organisationDetails: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            onError,
            getImageUrl,
            countrydata,
            subscriptionList: [],
            orgPlans: [],
            billingManagerList: [],
            isInvite: false,
            isAddPayment: false,
            isInvoice: false,
            card: {
                number: '',
                name: '',
                cvc: '',
                expiry: '',
            },
            invoiceDetail: {},
            backupInvoiceDetail: {},
            tableData: [],
            columns: ['date', 'invoice_number', 'amount', 'status', 'action'],
            tableSettings: {
                headings: {
                  date: 'Date',
                  invoice_number: 'Invoice number',
                  action: 'Action',
                  status: 'Status',
                  amount: 'Amount',
                },
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            paymentList: [],
            isFetchingList: false,
            expiryDateValidation: function (rule, value, callback) {
                const regex = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/
                if(value && !regex.test(value)){
                    callback(new Error(window.i18next.t('Invalid expiry date')));
                } else{
                    callback();
                }
            },
            validateCreditCard: function (rule, value, callback) {
                const visa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
                const mastercard = new RegExp("^5[1-5][0-9]{14}$");
                if ((value && visa.test(value)) || (value && mastercard.test(value))) callback()
                else callback(new Error(window.i18next.t('Invalid credit card')))
            },
            validateNumber: function (rule, value, callback) {
                const regex = /^[0-9]*$/
                if (value && !regex.test(value)) callback(new Error(window.i18next.t('Invalid CVC')))
                else callback()
            },
            validatePostalCode: this.validatePostalCodeFunction,
            permissions: permissions
        }
    },
    computed: {
        ...mapGetters(['hasPermission']),
        selectedOrganisationPlan () {
            return find(this.orgPlans, {userExistingPlan: true})
        }
    },
    created () {
        this.planId = process.env.VUE_APP_PLAN_ORGANISATION_ID
    },
    mounted() {
        // to fetch org payment list
        if(this.hasPermission(permissions.listPaymentMethod)) this.getOrganisationPaymentList()
        // to get the sub list of ORG
        if(this.hasPermission(permissions.getOrgSubscription)) this.getSubscriptionList()
        // to fetch invoices list
        if(this.hasPermission(permissions.listInvoices)) this.fetchInvoicesList()
        // to fetch billing managers
        if(this.hasPermission(permissions.billingManagerList)) this.fetchBillingMangerList()
        // to fetch the billing address
        this.getBillingAddress()
        // fetch plans list 
        if(this.hasPermission(permissions.organisationPlanList)) this.fetchOrgPlanList()
    },
    methods: {
        /**
         * to close invite dialog
         */
        closeInviteDialog () {
            this.isInvite = false
        },
        /**
         * to close the 
         */
        closePaymentDialog () {
            this.isAddPayment = false
            this.isInvoice = false
            this.card = {
                number: '',
                name: '',
                cvc: '',
                expiry: '',
            }
        },
        
        /**
         * to get the list of payment cards added
         */
        getOrganisationPaymentList () {
            this.isFetchingList = true
            // api call
            getPaymentList({organisation: this.$route.params.id}).then(response => {
                // to get the list
                this.paymentList = response
            }).catch(error => {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
            }).finally(() => {
                this.isFetchingList = false
            })
        },
        addPayment () {
            this.$refs['addPayment'].validate((valid) => {
                if(!valid){
                    return
                }
                loader(this, true)
                let body = {...this.card}
                delete body.expiry
                let month = ''
                let year = ''
                // get month and year from exp date
                if (this.card.expiry.includes('/')) {
                    month = this.card.expiry.split('/')[0]
                    year = this.card.expiry.split('/')[1]
                } else {
                    month = this.card.expiry.match(/.{2}/g)[0];
                    year = this.card.expiry.match(/.{2}/g)[1];
                }
                body.exp_month = month
                body.exp_year= year
                // add org
                body.organisation = this.$route.params.id
                // api call
                addOganisationPayment(body).then(() => {
                    // refresh the list
                    this.getOrganisationPaymentList()
                    message(this, constants.messageType.SUCCESS, 'Payment method added successfully')
                    // close the diaolog
                    this.closePaymentDialog()
                    // clear the fields
                    this.clearFields()
                }).catch(error => {
                    // error message
                    message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                    // error handler for permissions
                    this.rolesErrorHandler(error)
                })
                .finally(() => {
                    loader(this, false)
                })
            })
        },
        /**
         * to detach the payemnt method
         */
        async removePayment (id) {
            try {
                loader(this, true)
               // api call
               await removeOganisationPayment(id, {organisation: this.$route.params.id})
               // refresh the list
               this.getOrganisationPaymentList()
               // success message
               message(this, constants.messageType.SUCCESS, 'Payment method removed successfully')
            } catch (error) {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                // error handler for permissions
                this.rolesErrorHandler(error)
            } finally {
                loader(this, false)
            }
        },
        /**
         * to clear the card details on success
         */
        clearFields () {
            this.card = {
                number: '',
                name: '',
                cvc: '',
                expiry: '',
            }
        },
        /**
         * to get the sub list of org
         */
        getSubscriptionList () {
            getOrgSubscriptionsList({organisation: this.$route.params.id}).then(response => {
                this.subscriptionList = response || []
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * set default card for future payments
         */
        async setDefaultMethod (payment_method_id) {
            try {
                loader(this, true)
                // body for api
                let body = {
                    payment_method_id,
                    organisation: this.$route.params.id
                }
                // api call
                let response = await changeDefaultOrgPayment(body)
                if (response) {
                    // clone copy the list
                    let paymentList = cloneDeep(this.paymentList)
                    // change the default of list
                    this.paymentList = paymentList.map(payment => {
                        if (payment.id === payment_method_id) payment.is_default = true
                        else payment.is_default = false
                        return payment
                    })
                    message(this, constants.messageType.SUCCESS, 'Payment method marked as default successfully')
                }
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                // error handler for permissions
                this.rolesErrorHandler(error)
            }
            finally {
                loader(this, false)
            }
        },
        /**
         * to fetch the org invoices list
         */
        fetchInvoicesList () {
            getInvoicesList({organisation: this.$route.params.id})
            .then(response => {
                this.tableData = response || []
            })
            .catch(error => {
                console.error(error)
            })
        },
        /**
         * to get the date and show it in table
         * @param {*} date 
         */
        getDate (date) {
            if (date !== undefined && date !== null) {
              let d = new Date(date*1000)
              return ('0' + d.getDate()).slice(-2) + ' ' + d.toLocaleString('default', { month: 'long' })
              + ', ' + d.getFullYear()
            }
        },
        /**
         * download invoice
         */
        downloadInvoice(url) {
            openInNewTab(url)
        },

        /**
         * to fetch the list of billing managers
         */
        fetchBillingMangerList () {
            getBillingManagerList({organisation: this.$route.params.id})
            .then(response => {
                this.billingManagerList = response || []
            })
            .catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                // error handler for permissions
                this.rolesErrorHandler(error)
            })
        },
        /**
         * to remove billing managers from ORG
         */
        async deleteBillingManager (manager) {
            const mainTitle = `${window.i18next.t(`Remove billing manager`)} `;
            const nameTitle = `${manager.first_name} ${manager.last_name}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove a billing manager, you can no longer make any changes to it')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to remove the billing manager, it can not be undone')}?
                    </div>                    
                </div>`
                // confirmation box
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Remove'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(async() => {
                    loader(this, true)
                    // api all
                    try {
                        loader(this, true)
                        // body for api
                        let body = {
                            organisation: this.$route.params.id,
                            entity_id: manager._id
                        }
                        // api call
                        let response = await removeBillingManager(body)
                        let billingManagerList = cloneDeep(this.billingManagerList)
                        if (response.success) {
                            this.billingManagerList = billingManagerList.filter(list => {
                                if (list._id !== manager._id) return list
                            })
                        }
                    } catch (error) {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, this.$store.getters.getUserInformation.id ? {name: pageRoute.usersOverview, params: {id: this.$store.getters.getUserInformation.id}} : {})))
                        // error handler for permissions
                        this.rolesErrorHandler(error)
                    }
                    loader(this, false)
                }).catch(() => {
                    console.error('cancel button clicked')
                })
        },

        /**
         * disable button for update 
         * invoice customer detail 
         */
        disableUpdateInvoiceButton () {
            if ((this.invoiceDetail.name !== this.backupInvoiceDetail.name) || (this.invoiceDetail.postal_code !== this.backupInvoiceDetail.postal_code) || (this.invoiceDetail.city !== this.backupInvoiceDetail.city) || (this.invoiceDetail.country !== this.backupInvoiceDetail.country) || (this.invoiceDetail.vat !== this.backupInvoiceDetail.vat) || (this.invoiceDetail.line1 !== this.backupInvoiceDetail.line1) || (this.invoiceDetail.line2 !== this.backupInvoiceDetail.line2)) return false
            return true
        },

        /**
         * update the invoice form
         */
        updateInvoice () {
            // validate form
            this.$refs['invoiceForm'].validate(async(valid) => {
                if(!valid){
                    return
                }
                try {
                    loader(this, true)
                    // body for api
                    let body = {
                        name: this.invoiceDetail.name,
                        vat: this.invoiceDetail.vat,
                        organisation: this.$route.params.id,
                        address: {
                            line1: this.invoiceDetail.line1,
                            line2: this.invoiceDetail.line2,
                            city: this.invoiceDetail.city,
                            country: this.invoiceDetail.country_code,
                            postal_code: this.invoiceDetail.postal_code,
                        }
                    }
                    // if vat is not changed delete it from the object
                    if (this.invoiceDetail.vat === this.backupInvoiceDetail.vat) delete body.vat
                    // api call
                    let response = await updateBillingCustomer(body)
                    if (response.stripeError && response.stripeError.length > 0) {
                        // on error save all fields except vat
                        let invoiceDetail = {...this.invoiceDetail}
                        invoiceDetail.vat = ''
                        this.backupInvoiceDetail = invoiceDetail
                        message(this, constants.messageType.ERROR, (response.stripeError[0].message || 'Error in VAT'))
                    } else {
                        message(this, constants.messageType.SUCCESS, 'Updated successfully')
                        this.closePaymentDialog()
                        this.backupInvoiceDetail = cloneDeep(this.invoiceDetail)
                    }
                } catch (error) {
                    message(this, constants.messageType.ERROR, error.message)
                    // error handler for permissions
                    this.rolesErrorHandler(error)
                }
                loader(this, false)
            })  
        },
        /**
         * to update the formData
         */
        updateInvoiceFormData (data) {
            this.invoiceDetail = {
                name: data.name || '',
                vat: data.vat || '',
                line1: (data.address && data.address.line1) || '',
                line2: (data.address && data.address.line2) || '',
                city: (data.address && data.address.city) || '',
                country_code: (data.address && data.address.country) || '',
                postal_code: (data.address && data.address.postal_code) || '',
                country_name: this.getCountryName((data.address && data.address.country) || '')
            }
            this.backupInvoiceDetail = cloneDeep(this.invoiceDetail)
        },

        getCountryName (code) {
            let result = ''
            if (code && code !== '' && !isEmpty(this.countries)) {
                filter(this.countries, (country) => {
                    if (country.country_code === this.address.country_code) {
                        result = country.country_name;
                        // fetch state list initially
                        this.fetchStateList(country)
                    }
                })
            }
            return result
        },

        handleInputConfirm (item) {
            this.invoiceDetail.country_code = item.country_code || ''
            this.invoiceDetail.country_name = item.country_name || ''
            this.states = [];
            this.searchState = ''
            this.selectedState = {}
            this.fetchStateList(item)
        },
        querySearch: async function (search, cb) {
            if (search === '' && search === null && search.length < 1) return 
            let results = []
            if (!isEmpty(this.countries)) {
                 results = await filter(this.countries, (c) => {
                   return c.country_name.toLowerCase().includes(search.toLowerCase())
                })
            }
            cb(results)
        },
        /**
         * to fetch the billing address
         */
        getBillingAddress () {
            // api call
            getBillingCustomer({organisation: this.$route.params.id}).then(response => {
                let customer = response.customer || {}
                customer.vat = (response.vatDetails && response.vatDetails.value) || ''
                this.updateInvoiceFormData(customer)
            }).catch(error => {
                // error handler for permissions
                this.rolesErrorHandler(error)
            })
        },
        /**
         * create and download dynamic html 
         * file for domain verification 
         * @param {*} content 
         * @param {*} mime_type 
         */
        downloadFile(content = 'dhuCW0B8My5ZtxX77DNiR6rcutRdlS', mime_type) {
            mime_type = mime_type || "text/plain";
    
            var blob = new Blob([content], {type: mime_type});
    
            var dlink = document.createElement('a');
            dlink.download = content+'.html';
            dlink.href = window.URL.createObjectURL(blob);
            dlink.onclick = function() {
                // revokeObjectURL needs a delay to work properly
                var that = this;
                setTimeout(function() {
                    window.URL.revokeObjectURL(that.href);
                }, 1500);
            };
    
            dlink.click();
            dlink.remove();
        },

        /**
         * fetch org plan list
         */
        fetchOrgPlanList () {
            getOrgPlanList({organisation: this.$route.params.id}).then(response => {
                const plans = cloneDeep(response.plans || [])
                const firstPlan = remove(plans, plan => plan.id === this.planId)
                this.orgPlans = [...firstPlan, ...plans]
            }).catch(error => {
                console.error(error)
            })
        },

        /**
         * change org plan
         */
        changeBillingPlan (planToBeUpgraded) {
            loader(this, true)
            // body for api
            const body = {
                organisation: this.$route.params.id,
                new_plan: planToBeUpgraded.id || planToBeUpgraded._id,
                old_plan: this.selectedOrganisationPlan && this.selectedOrganisationPlan.id || ''
            }
            // api call
            changeOrgPlan(body).then(() => {
                this.fetchOrgPlanList()
                this.fetchInvoicesList ()
                message(this, constants.messageType.SUCCESS, 'Plan changed')
                loader(this, false)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                loader(this, false)
            })
        },
        /**
         * validate postal code
         * @param {*} rule 
         * @param {*} value 
         * @param {*} callback 
         */
         validatePostalCodeFunction (rule, value, callback) {
            let regex = ''
            if (this.invoiceDetail.country_code && this.invoiceDetail.country_code !== '') {
                // find the address code and regex
                const code = find(countryCode, {abbrev: this.invoiceDetail.country_code})
                regex = (code && code.postal) || ''
            }
            // validate postal code on basis of regex
            if (regex !== '' && value && value !== '' && !new RegExp(regex).test(value)) callback(new Error('Invalid Postal code'))
            else callback()
        },
    }
}